import Video from 'twilio-video';
import { useCallback, useEffect, useRef, useState } from 'react';
import { isMobile } from '../../helpers';
export const useRoom = (localTracks, { onError, onConnected, onDisconnected }, options) => {
    const [room, setRoom] = useState(null);
    const [isConnecting, setIsConnecting] = useState(false);
    const optionsRef = useRef(options);
    useEffect(() => {
        optionsRef.current = options;
    }, [options]);
    const connect = useCallback((token, _localTracks = localTracks) => {
        setIsConnecting(true);
        return Video.connect(token, Object.assign(Object.assign({}, optionsRef.current), { tracks: _localTracks })).then((newRoom) => {
            setRoom(newRoom);
            const disconnect = () => {
                newRoom.disconnect();
                onDisconnected();
            };
            newRoom.setMaxListeners(16);
            onConnected({
                audio: newRoom.localParticipant.audioTracks.size > 0,
                video: newRoom.localParticipant.videoTracks.size > 0
            });
            newRoom.once('disconnected', () => {
                // Reset the room only after all other `disconnected` listeners have been called.
                setTimeout(() => {
                    setRoom(null);
                });
                window.removeEventListener('beforeunload', disconnect);
                if (isMobile()) {
                    window.removeEventListener('pagehide', disconnect);
                }
            });
            newRoom.localParticipant.videoTracks.forEach((publication) => publication.setPriority('low'));
            setIsConnecting(false);
            window.addEventListener('beforeunload', disconnect);
            if (isMobile()) {
                window.addEventListener('pagehide', disconnect);
            }
        }, (error) => {
            onError(error);
            setIsConnecting(false);
        });
    }, [localTracks, onError, onConnected, onDisconnected]);
    return { room, isConnecting, connect };
};
//# sourceMappingURL=useRoom.js.map